import type { ESN } from './identifier';

export enum DeviceState {
  Enabled = 'enabled',
  Disabled = 'disabled',
  Disabling = 'disabling',
}

export enum DisablerStatus {
  Enabled = 'enabled',
  Disabled = 'disabled',
  Disabling = 'disabling',
  EnablePending = 'enable_pending',
  DisablePending = 'disable_pending',
}

/*
  This interface deals with the current state of a disabler device
*/
export interface DisablerEvent {
  deviceId: ESN;
  lastAction: DeviceState;
  lastKnownDeviceState: DeviceState;
  status: DisablerStatus;
}

export enum DisablerAction {
  Block = 'block',
  Unblock = 'unblock',
  CancelBlock = 'cancel block',
  CancelUnblock = 'cancel unblock',
}

/*
  This interface deals with the intent of blocking or unblocking a disabler device by an user
*/
export interface DisablerDevice {
  deviceId: ESN;
  action: DisablerAction;
}

export type VehiclesByDisablerStatus = { [key in DisablerStatus]?: boolean };
